module.exports = __webpack_public_path__ + "img/h_dog_pt_rnd_setsku.prt.961f0917.jpg";